import "core-js/modules/es.number.constructor";
import "core-js/modules/es.string.trim";
import _classCallCheck from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/inherits";
import { __decorate } from "tslib";
import Vue from 'vue';
import { Component, Prop, Emit, Watch } from 'vue-property-decorator';

var AppSimpleTextField = /*#__PURE__*/function (_Vue) {
  _inherits(AppSimpleTextField, _Vue);

  var _super = _createSuper(AppSimpleTextField);

  function AppSimpleTextField() {
    var _this;

    _classCallCheck(this, AppSimpleTextField);

    _this = _super.apply(this, arguments);
    _this.model = '';
    return _this;
  }

  _createClass(AppSimpleTextField, [{
    key: "mounted",
    value: function mounted() {
      this.model = this.value;
    }
  }, {
    key: "onValueChanged",
    value: function onValueChanged(val) {
      this.model = val ? this.$R.trim(val) : '';
    }
  }, {
    key: "valueChangedHandler",
    value: function valueChangedHandler(val) {
      this.model = val;

      if (!val) {
        return '';
      }

      return this.$R.trim(val);
    }
  }]);

  return AppSimpleTextField;
}(Vue);

__decorate([Prop(String)], AppSimpleTextField.prototype, "value", void 0);

__decorate([Prop(String)], AppSimpleTextField.prototype, "label", void 0);

__decorate([Prop({
  type: String
})], AppSimpleTextField.prototype, "placeholder", void 0);

__decorate([Prop({
  type: [Number, String],
  default: '289'
})], AppSimpleTextField.prototype, "width", void 0);

__decorate([Prop({
  type: [Number, String],
  default: 36
})], AppSimpleTextField.prototype, "height", void 0);

__decorate([Prop({
  type: String
})], AppSimpleTextField.prototype, "prefix", void 0);

__decorate([Prop({
  type: String
})], AppSimpleTextField.prototype, "suffix", void 0);

__decorate([Prop({
  type: String
})], AppSimpleTextField.prototype, "prefixOut", void 0);

__decorate([Prop({
  type: String
})], AppSimpleTextField.prototype, "suffixOut", void 0);

__decorate([Watch('value')], AppSimpleTextField.prototype, "onValueChanged", null);

__decorate([Emit('input')], AppSimpleTextField.prototype, "valueChangedHandler", null);

AppSimpleTextField = __decorate([Component], AppSimpleTextField);
export default AppSimpleTextField;